import auth from 'b2b-common/services/auth'

import privateView from './index'

import homeView from './home'
import accountView from './account'
import hotelViews from './hotel/router'
import bookingViews from './bookings/router'
import carHireView from './car_hire/search.vue'
import TransferView from './transfer/search.vue'
import { packageViews, tourViews } from './package/router'

// TODO: add routes for packages, tours and hotels (for Tudor to do)

export default {
  path: 'private',
  name: 'Private/Default',
  component: privateView,
  redirect: { name: 'Private/Home' },
  beforeEnter: (to, from, next) => {
    auth.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) next()
      else next({ name: 'Public/Default' })
    }, () => {
      next({ name: 'Public/Default' })
    })
  },
  children: [
    {
      path: 'home',
      name: 'Private/Home',
      component: homeView
    },
    packageViews,
    tourViews,
    hotelViews,
    bookingViews,
    {
      path: 'cont',
      name: 'Private/Account',
      component: accountView
    },
    {
      path: 'car_hire',
      name: 'Private/CarHire',
      component: carHireView
    },
    {
      path: 'transfers',
      name: 'Private/Transfer',
      component: TransferView
    },
    {
      path: 'logout',
      name: 'Private/Logout',
      beforeEnter: (to, from, next) => {
        auth.logout()
          .then(() => {
            // TODO: inform of succcesful logout
            next({ name: 'Public/Default' })
          })
          .catch(() => {
            // TODO: inform user about problem
            next({ name: 'Private/Default' })
          })
      }
    }
  ]
}
